export const table_columns = [
  {
    name: "playbook",
    icon: "Playbook",
    center: false,
  },
  {
    name: "ran by",
    icon: "User",
    center: false,
  },
  {
    name: "source & app",
    center: true,
  },
  {
    name: "information",
    icon: "Label",
    center: false,
  },
  {
    name: "findings",
    icon: "Bulb",
    center: false,
  },
  {
    name: "results",
    icon: "list",
    center: false,
  },
];
